export default `:host {
  display: block;
  position: fixed;
  transition: box-shadow var(--ids-motion-duration) var(--ids-motion-ease), transform var(--ids-motion-duration) var(--ids-motion-ease);
}

:host([hidden]) {
  display: none;
}

:host([edge=bottom]) {
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateY(100%);
}

:host([edge=bottom][visible]) {
  transform: translateY(0);
}

:host([edge=start]:not([dir])) {
  bottom: 0;
  left: 0;
  top: 0;
  transform: translateX(-100%);
}

:host([edge=start][visible]) {
  transform: none;
}

:host([dir=rtl][edge=start]) {
  bottom: 0;
  right: 0;
  top: 0;
  transform: translateX(100%);
}

:host([dir=rtl][edge=start][visible]) {
  transform: none;
}

.ids-drawer {
  height: 100%;
  width: 100%;
}
.ids-drawer.type-action-sheet {
  background-color: var(--ids-drawer-action-sheet-color-background);
  box-shadow: var(--ids-drawer-action-sheet-shadow);
  color: var(--ids-drawer-action-sheet-color-text);
  padding: var(--ids-space-12);
  margin: 0 auto;
  max-height: 70vh;
  max-width: 480px;
  min-height: 150px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.ids-drawer.type-app-menu {
  background-color: var(--ids-drawer-app-menu-color-background);
  border-inline-end: 1px solid var(--ids-drawer-app-menu-color-border);
  color: var(--ids-drawer-app-menu-color-text);
  min-width: var(--ids-drawer-width);
  width: var(--ids-drawer-width);
}
.ids-drawer.type-app-menu ::slotted(ids-text) {
  color: inherit;
}
.ids-drawer.type-app-menu.visible {
  box-shadow: var(--ids-drawer-app-menu-shadow);
}
@media (min-width: 927px) {
  .ids-drawer.type-app-menu.visible {
    box-shadow: none;
  }
}
.ids-drawer.type-module-nav {
  background-color: var(--ids-module-nav-background-color);
  color: var(--ids-module-nav-text-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
